import { render, staticRenderFns } from "./VUserAvatar.vue?vue&type=template&id=45187092&scoped=true&"
import script from "./VUserAvatar.vue?vue&type=script&lang=ts&"
export * from "./VUserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./VUserAvatar.vue?vue&type=style&index=0&id=45187092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45187092",
  null
  
)

export default component.exports